
document.addEventListener("DOMContentLoaded", function () {


    // NAVBAR SCROLL 
    window.onscroll = function () { myFunction() };
    var navbar = document.getElementById("navbar");
    var sticky = navbar.offsetTop;
    function myFunction() {
        if (window.pageYOffset >= sticky) {
            navbar.classList.add("sticky");
            document.querySelector('.header').style.marginTop = "130px";
        } else {
            navbar.classList.remove("sticky");
            document.querySelector('.header').style.marginTop = "0";
        }
    }
    // RECHERCHE
    document.querySelector('.navbar-rechercher a').addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelector('.searchbar').classList.toggle('show');
    });

});

// LAZYLOAD
var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
});


//FORMULAIRE REJOINDRE L'OBSERVATOIRE 

//SI GROUPE, AFFICHAGE MODAL
var groupe = jQuery(".radioboxGroupeInde > ul");
var submitButton = jQuery('#wpforms-submit-262');
var radioChecked = jQuery(".radioboxGroupeInde > ul li > input");
var modal = document.getElementById("myModal");
var span = document.getElementsByClassName("close")[0];
//     groupe.change(function () {
//         if (radioChecked[1].checked === true) {
//             displayModal();
//         }
// });
// submitButton.click(function (){
//     if (radioChecked[1].checked === true) {
//         displayModal();
//     }
//     else {
//         submitButton.click();
//     }
// });

function displayModal() {
        // submitButton.setAttribute('disabled', true);
        modal.style.display = "block";
        span.onclick = function() {
            // radioChecked[0].click();
            modal.style.display = "none";
            radioChecked.prop('checked', false);
        };
        window.onclick = function(event) {
            // radioChecked[0].click();
            // radioChecked[1].setAttribute( 'disabled', true);
            if (event.target == modal) {
                modal.style.display = "none";
                radioChecked.prop('checked', false);
            }
        };

}

//AFFICHAGE BLOC AUTRE SYNDICAT SI "AUTRE OU AUCUN" SELECTIONNE
var blocCacheAutreSyndicat = document.getElementById("wpforms-262-field_28-container");
var selectSyndicat= jQuery('select[name="wpforms[fields][12]"]');
    selectSyndicat.change(function() {
        if (selectSyndicat[0].value === "Autre ou aucun") {
            blocCacheAutreSyndicat.style.visibility = 'visible';
        } else {
            blocCacheAutreSyndicat.style.visibility = 'hidden';
        };
    }) ;


//AFFICHAGE BLOCS NOM+EDITEUR LOGICIEL SI "AUTRE" SELECTIONNE
var blocCacheNomLogiciel = document.getElementById("wpforms-262-field_14-container");
var blocCacheNomEditeur = document.getElementById("wpforms-262-field_17-container");
var selectLogiciel = jQuery('select[name="wpforms[fields][27]"]');
    selectLogiciel.change(function () {
        if (selectLogiciel[0].value === "AUTRE"){
            blocCacheNomEditeur.classList.add('d-block');
            blocCacheNomLogiciel.classList.add('d-block');
        } else {
            blocCacheNomEditeur.classList.remove('d-block');
            blocCacheNomLogiciel.classList.remove('d-block');
        }
    })

//AFFICHAGE POP UP AU SUBMIT DU FORM
var btnSubmit = jQuery("#wpforms-submit-262");
var beforeSubmit = document.getElementById("beforeSubmit");
        btnSubmit.mouseover( function () {
           beforeSubmit.classList.add('d-block');
          });
        btnSubmit.mouseout( function () {
            beforeSubmit.classList.remove('d-block');
        });